import { Pipe } from '@angular/core';
import { isArray, sum } from '../utils/utils';
var MeanPipe = (function () {
    function MeanPipe() {
    }
    MeanPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        var count = input.length;
        if (count === 0) {
            return undefined;
        }
        return sum(input) / count;
    };
    return MeanPipe;
}());
export { MeanPipe };
MeanPipe.decorators = [
    { type: Pipe, args: [{
                name: 'mean'
            },] },
];
/** @nocollapse */
MeanPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=mean.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/aggregate/mean.pipe.js
// module id = 224
// module chunks = 103